import React from 'react';
import { Phone, AlertTriangle, CheckCircle, Wrench } from 'lucide-react';
export function DriveShaftRepairPage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-5785">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white py-16" data-id="element-5786">
        <div className="container mx-auto px-4" data-id="element-5787">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-5788">
            Drive Shaft Repair
          </h1>
          <p className="text-xl text-gray-100 text-center" data-id="element-5789">
            Drive Shaft Repair near you! Farmington Hills, Farmington, Novi,
            Livonia, Northville
          </p>
          <p className="text-lg text-gray-200 text-center mt-2" data-id="element-5790">Since 1958</p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12" data-id="element-5791">
        <div className="max-w-4xl mx-auto" data-id="element-5792">
          {/* Introduction */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-5793">
            <p className="text-lg text-gray-700 mb-4" data-id="element-5794">
              The drive shaft turns your axles, and your axle (or axles if it's
              a 4X4) turns your wheels. There are different types of drivelines
              depending on whether your vehicle has rear wheel drive, front
              wheel drive (FWD), four-wheel drive (4WD or 4X4), or all-wheel
              drive (AWD).
            </p>

            <p className="text-lg text-gray-700 mb-4" data-id="element-5795">
              The driveline (drive shaft) connects to the transmission and
              differential through a series of universal joints (often called
              u-joints).
            </p>

            <p className="text-lg text-gray-700" data-id="element-5796">
              Most universal and CV joints are sealed and don't require periodic
              lubrication. However, it's extremely important to have them
              inspected once a year and every time your vehicle is up on a lift
              (while getting oil changes).
            </p>
          </div>

          {/* Warning Signs */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-5797">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-5798">
              Is your drive shaft in need of repair? Do your CV joints or
              universal joints need repair?
            </h2>

            <p className="text-lg text-gray-700 mb-6" data-id="element-5799">
              You may have a problem with your drive shaft, universal joints or
              CV joints if you experience any of the following conditions:
            </p>

            <div className="space-y-4" data-id="element-5800">
              <div className="flex items-start bg-red-50 border-l-4 border-red-500 p-4" data-id="element-5801">
                <AlertTriangle className="text-red-600 mr-3 flex-shrink-0 mt-1" size={24} data-id="element-5802" />
                <div data-id="element-5803">
                  <p className="font-bold text-gray-900" data-id="element-5804">
                    1. Vibration While Driving
                  </p>
                  <p className="text-gray-700" data-id="element-5805">
                    The car or truck vibrates while driving down the road
                  </p>
                </div>
              </div>

              <div className="flex items-start bg-red-50 border-l-4 border-red-500 p-4" data-id="element-5806">
                <AlertTriangle className="text-red-600 mr-3 flex-shrink-0 mt-1" size={24} data-id="element-5807" />
                <div data-id="element-5808">
                  <p className="font-bold text-gray-900" data-id="element-5809">2. Clunking Sound</p>
                  <p className="text-gray-700" data-id="element-5810">
                    A clunking sound is heard upon putting the car or truck in
                    reverse or drive
                  </p>
                </div>
              </div>

              <div className="flex items-start bg-red-50 border-l-4 border-red-500 p-4" data-id="element-5811">
                <AlertTriangle className="text-red-600 mr-3 flex-shrink-0 mt-1" size={24} data-id="element-5812" />
                <div data-id="element-5813">
                  <p className="font-bold text-gray-900" data-id="element-5814">
                    3. Squeaking at Low Speeds
                  </p>
                  <p className="text-gray-700" data-id="element-5815">
                    A squeaking sound is heard while driving at lower speeds
                  </p>
                </div>
              </div>
            </div>
          </div>

          {/* Images */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-5816">
            <div className="grid md:grid-cols-3 gap-4" data-id="element-5817">
              <div className="text-center" data-id="element-5818">
                <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/driveline%2520002.jpg200x200.jpg?opt=w3" alt="Drive shaft repair" className="w-full h-auto rounded-lg shadow-sm" data-id="element-5819" />
              </div>
              <div className="text-center" data-id="element-5820">
                <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/driveline%2520009.jpg200x200.jpg?opt=w3" alt="Universal joint repair" className="w-full h-auto rounded-lg shadow-sm" data-id="element-5821" />
              </div>
              <div className="text-center" data-id="element-5822">
                <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/driveline%2520007.jpg200x200.jpg?opt=w3" alt="CV joint repair" className="w-full h-auto rounded-lg shadow-sm" data-id="element-5823" />
              </div>
            </div>
          </div>

          {/* Services Header */}
          <div className="bg-[#B1050B] text-white rounded-lg shadow-md p-6 mb-8 text-center" data-id="element-5824">
            <h2 className="text-2xl font-bold" data-id="element-5825">
              We service and repair the following drive shafts, CV Joints,
              Universal Joints (U-Joints)
            </h2>
          </div>

          {/* Services Grid */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-5826">
            <div className="grid md:grid-cols-2 gap-8" data-id="element-5827">
              {/* Passenger Cars */}
              <div data-id="element-5828">
                <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center" data-id="element-5829">
                  <Wrench className="mr-2 text-[#B1050B]" size={24} data-id="element-5830" />
                  Passenger Car Repair
                </h3>
                <p className="text-lg text-gray-700 mb-4" data-id="element-5831">
                  Drive Shaft, CV Joint, Universal Joint Repair (foreign or
                  domestic)
                </p>

                <div className="space-y-3 mb-4" data-id="element-5832">
                  <div className="flex items-start" data-id="element-5833">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-5834" />
                    <span className="text-gray-700" data-id="element-5835">
                      Honda, Toyota, Nissan, Lexus, Audi, Land Rover, Porsche,
                      BMW, Mercedes and more
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-5836">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-5837" />
                    <span className="text-gray-700" data-id="element-5838">
                      Ford, Jaguar, GM, Chevrolet, Chrysler, Dodge, Jeep and
                      more
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-5839">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-5840" />
                    <span className="text-gray-700" data-id="element-5841">
                      Pick-ups and vans (foreign and domestic)
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-5842">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-5843" />
                    <span className="text-gray-700" data-id="element-5844">
                      4x4 vehicles, CV joints, and universal joints
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-5845">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-5846" />
                    <span className="text-gray-700" data-id="element-5847">
                      Limousines, race cars, custom cars, and more
                    </span>
                  </div>
                </div>
              </div>

              {/* Trucks */}
              <div data-id="element-5848">
                <h3 className="text-2xl font-bold text-gray-900 mb-4 flex items-center" data-id="element-5849">
                  <Wrench className="mr-2 text-[#B1050B]" size={24} data-id="element-5850" />
                  Truck Repair
                </h3>
                <p className="text-lg text-gray-700 mb-4" data-id="element-5851">
                  Drive Shaft, CV Joint, Universal Joint (U-Joint) Repair (all
                  sizes, foreign or domestic)
                </p>

                <div className="space-y-3 mb-4" data-id="element-5852">
                  <div className="flex items-start" data-id="element-5853">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-5854" />
                    <span className="text-gray-700" data-id="element-5855">
                      Ford F150, F250, F350, F450, F550 Super Duty pick up
                      trucks
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-5856">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-5857" />
                    <span className="text-gray-700" data-id="element-5858">
                      Chevrolet (Chevy) and GM trucks, four-wheel drive
                      (4WD/4X4)
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-5859">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-5860" />
                    <span className="text-gray-700" data-id="element-5861">Dodge Trucks</span>
                  </div>
                  <div className="flex items-start" data-id="element-5862">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-5863" />
                    <span className="text-gray-700" data-id="element-5864">
                      Toyota trucks, Nissan Trucks, Honda and more
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-5865">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-5866" />
                    <span className="text-gray-700" data-id="element-5867">
                      Buses, RVs, and Coaches
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-5868">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-5869" />
                    <span className="text-gray-700" data-id="element-5870">
                      Agricultural Equipment, Construction Equipment
                    </span>
                  </div>
                  <div className="flex items-start" data-id="element-5871">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-5872" />
                    <span className="text-gray-700" data-id="element-5873">
                      PTO Shafts, Aluminum Drive-shafts, steel drive shafts and
                      more
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Summary */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-5874">
            <h2 className="text-2xl font-bold text-gray-900 mb-4 text-center" data-id="element-5875">
              Complete Drive Shaft Services
            </h2>
            <p className="text-lg text-gray-700 text-center" data-id="element-5876">
              Drive Shaft Repair, Universal Joint Repair (U-Joint Repair), CV
              Joint Repair. Garretts is well prepared to inspect and repair
              drivelines, driveshafts, cv joints and universal joints (u-joints)
              for a wide range of vehicles from passenger cars and trucks
              (foreign and domestic) to heavy equipment, farm equipment,
              construction equipment, semi-trucks, race cars, custom cars and
              more. <strong data-id="element-5877">If it has a driveline, we can fix it.</strong>
            </p>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-lg shadow-xl p-8 text-center" data-id="element-5878">
            <h2 className="text-3xl font-bold mb-4" data-id="element-5879">Do you have a question?</h2>
            <p className="text-xl mb-6" data-id="element-5880">
              Expert Drive Shaft, CV Joint, and U-Joint Repair
            </p>
            <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-5881">
              <Phone className="mr-3" size={24} data-id="element-5882" />
              Call (248) 478-8382
            </a>
            <p className="mt-4 text-gray-300" data-id="element-5883">
              24175 Industrial Park Dr., Farmington Hills, MI 48335
            </p>
          </div>
        </div>
      </div>
    </div>;
}